import React from "react";
import MaterialIcon from "../BuilderComponents/MaterialIcon";
import FullMapWithMultiPin from "../../images/fullMapWithMultiPin.png";

const MapPreview = ({ classes, onClickElement }) => {
  const navigateEditMapCard = (e) => {
    e.stopPropagation();
    onClickElement({ type: "edit_map_card" });
  };
  return (
    <div className={`position_relative h_100 ${classes}`}>
      <MaterialIcon name="assistant_direction" className="position_absolute right_0" onClick={navigateEditMapCard} />
      <div className="h_100">
        <img className="w_100 h_100" style={{ objectFit: "cover" }} src={FullMapWithMultiPin} alt="FullMap" />
      </div>
    </div>
  );
};

export default MapPreview;
